import { useTranslation } from 'next-i18next'
// Dependencies.
import styled from 'styled-components'

import { Section } from '../Section'
import { H2 } from '../H2'
import { P } from '../P'

// Props.
interface Props {}

// Keep The Community Strong.
export const KeepCommunityStrong: React.FC<Props> = (props) => {
  const { t } = useTranslation('common')

  return (
    <Div>
      <Section>
        <H2>{t(`KeepCommunityStrong-1415028513`, `Be a part of our Klyk`)}</H2>
        <P>
          {t(
            `KeepCommunityStrong1082657817`,
            `We want to protect the integrity of our community. If you see any activity that may be in violation of these community guidelines, please bring this to our attention. This platform operates on the participation of a community that is diverse and autonomous, expressing a range of different values and beliefs. If you see something you don’t like, you can always choose to disengage with that person or activity.`,
          )}
          <br />
          <br />
          {t(
            `KeepCommunityStrong1346629494`,
            `We hope you get the most out of your experiences on Klyk. Thanks for joining us in creating a supportive, dynamic community.`,
          )}
          <br />
          <br />
          {t(`KeepCommunityStrong-2030223859`, `The Klyk team.`)}
        </P>
      </Section>
    </Div>
  )
}

// Div.
const Div = styled.div`
  padding-top: 40px;
  padding-bottom: 60px;
  margin: 0 auto;
  width: 100%;
  max-width: 664px;

  p {
    font-size: 24px;
  }
`
